import { CONTENT_URL } from "../api/Definitions"
import { eAudioVersions, iAudioVersions } from "../definitions/Audio"
import { eVideoVersions, iVideoVersions } from "../definitions/Video"

export function useAudioUrl(
  version: eAudioVersions = eAudioVersions.original,
  versions: iAudioVersions = {},
) {
  const pp = versions[eAudioVersions[version]]?.meta?.pipePath

  if (pp) {
    return `${CONTENT_URL}${pp}`
  }
  return ""
}
